import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_is_a_factor_in_decisions_on_promotion_or'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_is_a_factor_in_decisions_on_promotion_or',
  name: 'Which of the following is a factor in decisions on promotion or access to training?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'RACE_ETHNIC_GROUP_SKIN_COLOR',
      text: 'Race / Ethnic Group / Skin Color',
      externalIds: [
        {
          id: 'disc-6--1',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SEX_GENDER',
      text: 'Sex / Gender',
      externalIds: [
        {
          id: 'disc-6--2',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'RELIGION',
      text: 'Religion',
      externalIds: [
        {
          id: 'disc-6--3',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'POLITICAL_OPINION',
      text: 'Political Opinion',
      externalIds: [
        {
          id: 'disc-6--4',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NATIONAL_EXTRACTION',
      text: 'National Extraction',
      externalIds: [
        {
          id: 'disc-6--5',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SOCIAL_ORIGIN',
      text: 'Social Origin',
      externalIds: [
        {
          id: 'disc-6--6',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'DISABILITY',
      text: 'Disability',
      externalIds: [
        {
          id: 'disc-6--7',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HIV_AIDS_STATUS_REAL_OR_PERCEIVED_',
      text: 'HIV / AIDS Status (real or perceived)',
      externalIds: [
        {
          id: 'disc-6--8',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SEXUAL_ORIENTATION',
      text: 'Sexual Orientation',
      externalIds: [
        {
          id: 'disc-6--9',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PREGNANCY_MATERNITY_STATUS',
      text: 'Pregnancy / Maternity Status',
      externalIds: [
        {
          id: 'disc-6--10',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MARITAL_STATUS',
      text: 'Marital Status',
      externalIds: [
        {
          id: 'disc-6--11',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'AGE',
      text: 'Age',
      externalIds: [
        {
          id: 'disc-6--12',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NATIONALITY_FOREIGN_MIGRANT_WORKER_STATUS',
      text: 'Nationality / Foreign Migrant Worker Status',
      externalIds: [
        {
          id: 'disc-6--13',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FAMILY_RESPONSIBILITIES',
      text: 'Family responsibilities',
      externalIds: [
        {
          id: 'wt-dis-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'disc-6--14',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe what "Other" factor is considered in the promotion or access to training process:',
        externalIds: [
          {
            id: 'disc-6--14-1f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'RACE_ETHNIC_GROUP_SKIN_COLOR',
                'SEX_GENDER',
                'RELIGION',
                'POLITICAL_OPINION',
                'NATIONAL_EXTRACTION',
                'SOCIAL_ORIGIN',
                'DISABILITY',
                'HIV_AIDS_STATUS_REAL_OR_PERCEIVED_',
                'SEXUAL_ORIENTATION',
                'PREGNANCY_MATERNITY_STATUS',
                'MARITAL_STATUS',
                'AGE',
                'NATIONALITY_FOREIGN_MIGRANT_WORKER_STATUS',
                'FAMILY_RESPONSIBILITIES',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wt-dis-4',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 10730,
  sectionId: '2.2.5',
  impactArea: 'Discrimination, Violence or Harassment',
  impactAreaId: 'DISCRIMINATION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
